import { EnviromentVars } from '../config/env';
import Cookies from 'js-cookie';
export const TOKEN_KEY = EnviromentVars.cookieName;

// export const isAuthenticated = () => Cookies.load(TOKEN_KEY) !== null;
export const isAuthenticated = () => {
  return Cookies.get(EnviromentVars.cookieName) !== null;
};

export const getToken = () => {
  var data = Cookies.get(TOKEN_KEY);
  if (data !== undefined) {
    data = Buffer.from(data, 'base64').toString('utf8');
    data = JSON.parse(data);
    return data.token;
  } else {
    return;
  }
};

export const logOut = () => {
  Cookies.remove(EnviromentVars.cookieName, {
    domain: EnviromentVars.cookieDomain,
  });
};

export const getFromStorage = () => {
  let data = Cookies.get(EnviromentVars.cookieName);
  // Cookies.load(TOKEN_KEY);
  if (data !== undefined && data != null) {
    data = Buffer.from(data, 'base64').toString('utf8');
    data = JSON.parse(data);
    return data;
  } else {
    return;
  }
};

export const login = async (token) => {
  //
  //
  try {
    var _token = JSON.stringify(token);
    _token = Buffer.from(_token.toString()).toString('base64');
    Cookies.set(EnviromentVars.cookieName, _token, {
      domain: EnviromentVars.cookieDomain,
      sameSite: 'lax',
    });
  } catch (error) {
  }
};

export const saveMenuToStorage = (data) => {
  try {
    var _data = JSON.stringify(data);
    _data = Buffer.from(_data.toString()).toString('base64');
    sessionStorage.setItem(EnviromentVars.cookieName, _data);
  } catch (error) {
  }
};

export const getMenuToStorage = () => {
  let data = sessionStorage.getItem(EnviromentVars.cookieName);
  if (data !== undefined && data != null) {
    data = Buffer.from(data, 'base64').toString('utf8');
    data = JSON.parse(data);
    return data;
  } else {
    return;
  }
};
